import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  loadingSpinner: {
    marginTop: pxToRem(60),
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: pxToRem(16),
    fontWeight: 400,
  },
  saveButton: {
    marginRight: pxToRem(16),
  },
  moduleHeaderText: {
    ...theme.fonts.large,
    selectors: {
      [layout.breakpoints.min.md]: {
        ...theme.fonts.xLarge,
      },
    },
  },
});
